import { render, staticRenderFns } from "./VideoGuides.vue?vue&type=template&id=b607a9f0"
import script from "./VideoGuides.vue?vue&type=script&lang=ts"
export * from "./VideoGuides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports